import React, { useState } from "react";
import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { Envelope, Person, Send, ShieldCheck } from "react-bootstrap-icons";
import axios from "axios";
import API_BASE_URL from "../config/api";
import PublicLayout from "../components/PublicLayout";

const initialForm = {
  name: "",
  email: "",
  message: "",
};

const ContactUs = () => {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSuccess("");
    setError("");

    try {
      setSubmitting(true);
      await axios.post(`${API_BASE_URL}/api/contact-us`, form, {
        headers: { "Content-Type": "application/json" },
      });
      setSuccess("Thanks for contacting us. We will get back to you soon.");
      setForm(initialForm);
    } catch (err) {
      console.error("Contact form error:", err);
      setError("We could not send your message right now. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <PublicLayout
      eyebrow="Support"
      title="Contact Us"
      description="Tell us what you need and the Owner Builder team will follow up."
    >
      <Row className="g-4 align-items-stretch">
        <Col lg={5}>
          <div className="contact-info-panel">
            <div className="contact-icon">
              <ShieldCheck />
            </div>
            <h2>How we can help</h2>
            <p>
              Send questions about your account, project access, billing, or
              anything that is blocking your work.
            </p>
            <div className="contact-info-list">
              <div>
                <strong>Response window</strong>
                <span>Our team reviews new messages during business hours.</span>
              </div>
              <div>
                <strong>Include useful details</strong>
                <span>Share the page, project, or account issue you are seeing.</span>
              </div>
              <div>
                <strong>Privacy first</strong>
                <span>Avoid sending passwords or sensitive payment details.</span>
              </div>
            </div>
          </div>
        </Col>

        <Col lg={7}>
          <Card className="public-form-card">
            <Card.Body className="p-4 p-md-5">
              {success && <Alert variant="success">{success}</Alert>}
              {error && <Alert variant="danger">{error}</Alert>}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <div className="public-input-wrap">
                    <Person />
                    <Form.Control
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="Your name"
                      required
                      disabled={submitting}
                    />
                  </div>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <div className="public-input-wrap">
                    <Envelope />
                    <Form.Control
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="you@example.com"
                      required
                      disabled={submitting}
                    />
                  </div>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={7}
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="How can we help?"
                    required
                    disabled={submitting}
                  />
                </Form.Group>

                <div className="d-flex justify-content-end">
                  <Button className="public-submit-btn" type="submit" disabled={submitting}>
                    {submitting ? (
                      <>
                        <Spinner size="sm" animation="border" className="me-2" />
                        Sending...
                      </>
                    ) : (
                      <>
                        <Send className="me-2" />
                        Send Message
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </PublicLayout>
  );
};

export default ContactUs;
